document.addEventListener("DOMContentLoaded", function () {
// Get all tab buttons and content sections
  const tabButtons = document.querySelectorAll('.dropdown-menu .tab-button');
  const tabContentItems = document.querySelectorAll('.dropdown-menu .tab-content-item');

  // Add event listeners to each tab button
  tabButtons.forEach(button => {
      button.addEventListener('mouseenter', () => {
          const tabId = button.getAttribute('data-tab');

          // Remove the active class from all tab buttons and content items
          tabButtons.forEach(btn => btn.classList.remove('active'));
          tabContentItems.forEach(content => content.classList.remove('active'));

          // Add the active class to the clicked button and the corresponding content
          button.classList.add('active');
          document.getElementById(`tab-${tabId}`).classList.add('active');
      });
  });
});
